<script setup lang="ts">
import { useABTestingState } from '../../hooks/useABTestingState';
import { SwitchVariant } from '.';

const { isShowABTestingSideBar } = useABTestingState();
</script>
<template>
  <SwitchVariant v-if="isShowABTestingSideBar" />
</template>
